import type { FormInstance } from 'antd';
import { type TPlainObject, trim } from '@flatbiz/utils';

export const getFormFieldsValue = (
  form: FormInstance,
  filterFormItemKeys?: string[]
) => {
  const formValues = (form.getFieldsValue() || {}) as TPlainObject;
  if (!filterFormItemKeys?.length) {
    return formValues;
  }
  const values: TPlainObject = {};

  filterFormItemKeys.forEach((item) => {
    values[item] = formValues[item];
  });
  return values;
};

/**
 * 请求参数内部转换处理
 * ```
 * 1. 对象中值为空字符串、null、undefined 的key值，直接删除
 * 2. 对象中以`__#invalid_xxxx`开头的key值，直接删除
 * 3. 注意params可能会有嵌套，只考虑object嵌套
 * ```
 */
export const requestParamsInternalAdapter = (
  params: TPlainObject,
  options: {
    /** 移除值为空字符串字段 */
    removeEmptyValue?: boolean;
  } = {}
): TPlainObject => {
  if (!params || typeof params !== 'object' || Array.isArray(params)) {
    return params;
  }

  const { removeEmptyValue = true } = options;
  const result: TPlainObject = {};

  for (const key in params) {
    if (!Object.prototype.hasOwnProperty.call(params, key)) {
      continue;
    }

    let value = params[key];
    if (typeof value === 'string') {
      value = trim(value, true);
    }

    // 删除以 `__#invalid_` 开头的key
    if (
      key.includes('__#invalid_') ||
      (removeEmptyValue &&
        (value === '' || value === null || value === undefined))
    ) {
      continue;
    }

    // 处理嵌套对象
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      result[key] = requestParamsInternalAdapter(
        value as TPlainObject,
        options
      );
    } else {
      result[key] = value;
    }
  }

  return result;
};
